import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "components/loader";
import Alert from "components/alert";
import { HiChevronLeft } from "react-icons/hi";
import Footer from "components/footer/FooterAuthDefault";
import { Card, HStack, PinInput, PinInputField } from "@chakra-ui/react";
import logoImg from "assets/img/home/logo.png";
import { IoIosArrowRoundForward } from "react-icons/io";
import { RiLockPasswordFill } from "react-icons/ri";
import { PiPasswordBold, PiUserCircleCheck } from "react-icons/pi";
import {
  fetchForgotToken,
  fetchForgotTokenCheck,
  setActiveStepIndex,
} from "services/users/authSlice";
import { fetchForgotPasswordChange } from "services/users/authSlice";

export default function ForgotPassword() {
  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");
  const [error, setError] = useState(""); // For storing validation errors

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = useSelector((state) => {
    return state.auth;
  });

  const handleSubmit = async (e) => {
    if (!e.preventDefault()) {
      if (auth.forgot.activeStepIndex === 0) {
        await dispatch(fetchForgotToken({ username: username }));
      } else if (auth.forgot.activeStepIndex === 1) {
        if (code.length < 4) {
          setError("Кодыг бүрэн оруулна уу!"); // Display error message
          return;
        } else {
          setError(""); // Clear error if validation passes
          await dispatch(
            fetchForgotTokenCheck({ username: username, forgot_token: code })
          );
        }
      } else {
        if (password === rePassword) {
          const resultAction = await dispatch(
            fetchForgotPasswordChange({
              username: username,
              forgot_token: code,
              password: password,
            })
          );
          if (fetchForgotPasswordChange.fulfilled.match(resultAction)) {
            navigate("/admin");
          }
        }
      }
    }
  };

  return (
    <div className="w-full bg-purple-900 bg-opacity-80 h-screen overflow-hidden grid grid-rows-[auto,1fr,auto]">
      <div className="w-full h-full left-0 z-[2] lg:top-10 lg:left-10">
        <Link to="/">
          <HiChevronLeft className="h-16 w-16 text-white" />
        </Link>
      </div>
      <div className="w-full h-full grid grid-cols-[1fr,auto,1fr]">
        <div></div> {/* expanded */}
        <div className="h-full flex justify-center items-center">
          <Card extra={"items-center w-full h-full md:p-[16px] bg-cover"}>
            <form onSubmit={handleSubmit}>
              {/* Name and position */}
              <div className="mt-16 flex flex-col items-center md:pl-16 md:pr-16 pb-16">
                {" "}
                <img src={logoImg} className="mb-3 h-24" alt="" />{" "}
                {auth.loading && <Loader />}
                {!auth.loading && auth.error ? (
                  <Alert text={auth.error} />
                ) : null}
                <div className="border-slate-200 flex items-start justify-between rounded-t m-6">
                  <ol className="flex items-center w-full text-sm font-medium text-center text-gray-500 dark:text-gray-400 sm:text-base">
                    <li className={`flex md:w-full items-center `}>
                      <span className="flex items-center justify-center after:content-['/'] sm:after:hidden ">
                        <div className="ml-2 bg-color-red">
                          <PiUserCircleCheck
                            size={60}
                            className={
                              auth.forgot.activeStepIndex === 0
                                ? "text-terapist-active"
                                : auth.forgot.activeStepIndex > 0
                                ? "text-terapist-normal"
                                : "text-gray-600"
                            }
                          />
                        </div>
                        <div className="ml-5 mr-5">
                          <IoIosArrowRoundForward size={40} />
                        </div>
                        <PiPasswordBold
                          size={60}
                          className={
                            auth.forgot.activeStepIndex === 1
                              ? "text-terapist-active"
                              : auth.forgot.activeStepIndex > 1
                              ? "text-terapist-normal"
                              : "text-gray-600"
                          }
                        />
                        <div className="ml-5 mr-5">
                          <IoIosArrowRoundForward size={40} />
                        </div>

                        <RiLockPasswordFill
                          size={60}
                          className={
                            auth.forgot.activeStepIndex === 2
                              ? "text-terapist-active"
                              : auth.forgot.activeStepIndex > 2
                              ? "text-terapist-normal"
                              : "text-gray-600"
                          }
                        />
                      </span>
                    </li>
                  </ol>
                </div>
                {auth.forgot.activeStepIndex === 0 ? (
                  <div className="formInput w-full">
                    <label
                      htmlFor={"input"}
                      className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                    >
                      Хэрэглэгчийн нэр
                    </label>
                    <input
                      name="username"
                      type="text"
                      placeholder="e.g. manager"
                      value={username}
                      label="Хэрэглэгчийн нэр"
                      pattern="^[A-Za-z0-9]{3,16}$"
                      required={true}
                      id={"input"}
                      onChange={(e) => setUsername(e.target.value)}
                      className={` flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none w-full`}
                    />

                    <span id="error-msg">Хэрэглэгчийн нэрээ оруулна уу!</span>
                  </div>
                ) : auth.forgot.activeStepIndex === 1 ? (
                  <div>
                    <label
                      htmlFor="pininput"
                      className="text-sm font-bold text-navy-700 dark:text-white"
                    >
                      Баталгаажуулах код
                    </label>
                    <HStack className="mt-2 mb-3">
                      <PinInput
                        onChange={(value) => {
                          setCode(value); // Update state as user types
                          setError(""); // Clear error on input change
                        }}
                        type="alphanumeric"
                        size="lg"
                      >
                        <PinInputField />
                        <PinInputField />
                        <PinInputField />
                        <PinInputField />
                      </PinInput>
                    </HStack>
                    {error && (
                      <p className="text-red-500 text-sm mt-2">{error}</p>
                    )}{" "}
                  </div>
                ) : (
                  <div className="formInput w-full">
                    <label
                      htmlFor={"input"}
                      className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                    >
                      Шинэ нууц үг
                    </label>
                    <input
                      name="newPassword"
                      type="password"
                      placeholder="Шинэ нууц үг"
                      pattern="^.{5,10}$"
                      required={true}
                      id={"newPasswordInput"}
                      onChange={(e) => setPassword(e.target.value)}
                      className={` flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none w-full`}
                    />

                    <span id="error-msg">
                      Шинэ нууц үгээ оруулна уу! 5-аас дээш тэмдэгт байх ёстой.
                    </span>

                    <label
                      htmlFor={"input"}
                      className="ml-3 text-sm font-bold text-navy-700 dark:text-white"
                    >
                      Нууц үг давтах
                    </label>
                    <input
                      name="rePassword"
                      type="password"
                      placeholder="Нууц үг давтах"
                      pattern="^.{5,10}$"
                      required={true}
                      id={"rePasswordInput"}
                      onChange={(e) => setRePassword(e.target.value)}
                      className={` flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none w-full`}
                    />
                    {password !== rePassword ? (
                      <span
                        style={{
                          fontSize: "12px",
                          padding: "3px",
                          color: "red",
                        }}
                      >
                        Нууц үг таарахгүй байна
                      </span>
                    ) : null}
                  </div>
                )}
                <div className="grid grid-cols-2">
                  <button
                    type="button"
                    onClick={() => {
                      if (auth.forgot.activeStepIndex === 0) {
                        navigate("/admin");
                      } else if (auth.forgot.activeStepIndex > 0)
                        dispatch(
                          setActiveStepIndex(auth.forgot.activeStepIndex - 1)
                        );
                    }}
                    className={
                      "linear mt-2 rounded-xl bg-activeOrange px-5 text-base font-medium text-white transition duration-200 active:bg-gradOrange-100 w-full"
                    }
                  >
                    Буцах
                  </button>
                  <button
                    type="submit"
                    className={
                      "linear py-[12px] mt-2 rounded-xl bg-btn-1 px-5 text-base font-medium text-white transition duration-200 hover:bg-btn-2 active:bg-btn-3 ml-6 w-full"
                    }
                  >
                    Дараах
                  </button>
                </div>
              </div>
            </form>
          </Card>
        </div>{" "}
        {/* fixed width */}
        <div></div> {/* expanded */}
      </div>

      <div className="w-full h-full">
        <Footer />
      </div>
    </div>
  );
}
